import { render } from "./SectionsDashboardFacultySquareItem.vue?vue&type=template&id=1d5655a8"
import script from "./SectionsDashboardFacultySquareItem.vue?vue&type=script&lang=js"
export * from "./SectionsDashboardFacultySquareItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__